import React from 'react';
import styled from '@emotion/styled';
import { ButtonV2 } from '@bbkAdminComponents/buttons';
import Icons from '@bbkAdminUtils/icons';

type ButtonV2Props = React.ComponentProps<typeof ButtonV2>;
export const Done: React.FC<
  ButtonV2Props & { disabled?: boolean; label?: string }
> = ({ onClick, disabled = false, label = 'Done', children, ...props }) => (
  <ButtonV2
    primary
    onClick={onClick}
    disabled={disabled}
    css={{ display: 'flex', alignItems: 'center' }}
    {...props}
  >
    {children ?? (
      <>
        {Icons.checkmark}
        <span css={{ marginLeft: '0.5rem' }}>{label}</span>
      </>
    )}
  </ButtonV2>
);

export const CloseOverlay: React.FC<ButtonV2Props> = ({
  onClick,
  ...props
}) => (
  <ButtonV2
    circle
    onClick={onClick}
    css={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    {...props}
  >
    {Icons.closeProper}
  </ButtonV2>
);

export const Revert: React.FC<ButtonV2Props> = ({ onClick, ...props }) => (
  <ButtonV2
    onClick={onClick}
    css={{
      display: 'flex',
      alignItems: 'center',
    }}
    {...props}
  >
    <div
      css={{
        marginTop: '-3px',
        marginBottom: '-2px',
      }}
    >
      {Icons.resetArrow}
    </div>
    <span css={{ marginLeft: '.5rem' }}>Revert</span>
  </ButtonV2>
);

export const CopyShareLink: React.FC<ButtonV2Props> = ({
  onClick,
  ...props
}) => (
  <ButtonV2
    onClick={onClick}
    css={{
      display: 'flex',
      alignItems: 'center',
      svg: {
        height: 17,
      },
    }}
    {...props}
  >
    {Icons.link}
    <span css={{ marginLeft: '.5rem' }}>Copy share link</span>
  </ButtonV2>
);

export const Publish: React.FC<ButtonV2Props> = ({
  onClick,
  children,
  ...props
}) => (
  <ButtonV2
    success
    onClick={onClick}
    css={{
      display: 'flex',
      alignItems: 'center',
    }}
    {...props}
  >
    {children ?? (
      <>
        <div
          css={{
            marginTop: '-3px',
            marginBottom: '-2px',
          }}
        >
          {Icons.publish}
        </div>
        <span css={{ marginLeft: '.5rem' }}>Publish</span>
      </>
    )}
  </ButtonV2>
);

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dddfe2;
  background: #fff;
  min-height: 60px;
  position: sticky;
  top: 0;
  z-index: 20;
`;
